import BaseExcelService from './BaseExcelService';

class EquipmentExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/equipment';
  }
}

export default new EquipmentExcelService();
